var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-range-picker',{ref:"picker",attrs:{"opens":'right',"dateRange":{
    startDate: null,
    endDate: null,
  },"append-to-body":true,"auto-apply":true,"localeData":{
    direction: 'ltr',
    format: 'dd/mm/yyyy',
    separator: ' a ',
    applyLabel: 'Aplicar',
    cancelLabel: 'Cancelar',
    daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    monthNames: [
      'Jan',
      'Fev',
      'Mar',
      'Abr',
      'Mai',
      'Jun',
      'Jul',
      'Ago',
      'Set',
      'Out',
      'Nov',
      'Dez',
    ],
    firstDay: 0,
  },"ranges":false},on:{"update":_vm.update},scopedSlots:_vm._u([{key:"input",fn:function(picker){return [_vm._v("\n    Filtrando de "+_vm._s(_vm._f("date")(picker.startDate))+" até "+_vm._s(_vm._f("date")(picker.endDate))+"\n  ")]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }